// Style
import { amber, blue, blueGrey, brown, cyan, deepOrange, deepPurple, green, indigo, lightBlue, lightGreen, lime, orange, pink, purple, red, teal, yellow } from '@mui/material/colors/index.js';

/**
 * Predefined color palette for athlete avatars
 */
const AVATAR_COLORS = [
    teal[500], green[500], purple[500], deepPurple[500], lightBlue[500], cyan[500], 
    deepOrange[500], brown[500], blueGrey[500], lightGreen[500], lime[500], yellow[900], 
    amber[500], indigo[500], blue[500], orange[300], red[500], pink[500]
];

/**
 * Generate consistent color based on user email
 * @param {Object|string} userOrEmail - User object with profile.email or email string
 * @returns {string} Material-UI color value
 */
export const getConsistentAvatarColor = (userOrEmail) => {
    // Handle both user object and email string
    const email = typeof userOrEmail === 'string' 
        ? userOrEmail 
        : userOrEmail?.profile?.email || userOrEmail?.email;
    
    if (!email) return AVATAR_COLORS[0];
    
    // Simple hash function for consistent color assignment
    let hash = 0;
    for (let i = 0; i < email.length; i++) {
        hash = email.charCodeAt(i) + ((hash << 5) - hash);
    }
    
    return AVATAR_COLORS[Math.abs(hash) % AVATAR_COLORS.length];
};

/**
 * Get the full color palette
 * @returns {Array<string>} Array of Material-UI colors
 */
export const getAvatarColorPalette = () => {
    return AVATAR_COLORS;
};
